export default "mdc-list {\n  padding: 0;\n}"